import { withStyles } from '@material-ui/core/styles';

const styled = withStyles(theme => {
  return {
    container: {
      // maxWidth: 600,
      margin: '0px auto',
    },
    table: {
      // minWidth: 700,
    },
  };
});

export default styled;
